import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  ClaimApplicationsPendingDisbursement,
  staffClaimApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { 
  LeaveApplicationsColumns, 
  claimApplicationsPendingDisbursementColumns 
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ClaimApplicationForm from "./form";
import StaffClaimDocumentsDrawer from "./StaffClaimDocumentsDrawer";

const base_url = HRService.uri;

function ClaimPendingDisbursementTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  entity: "Claims Pending Disbursement",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  DISBURSECLAIM: {
    key: "DISBURSECLAIM",
    button_name: "Disburse",
    // Show only when the row is APPROVED (statusId = 3)
    Show_Button: (row) => row.statusId === 3,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

    ViewClaimLines: {
      key: "ViewClaimLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },

  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Claim Pending Disbursement"
          subtitle="View all your Claim , create or update it"
          columns={claimApplicationsPendingDisbursementColumns}
          query={ClaimApplicationsPendingDisbursement}
          actions={actions}
          base_url={base_url}
        />
        <StaffClaimDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          claimId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ClaimPendingDisbursementTable;